import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './ExpenseInfoScreen';
import ExpenseInfo from './ExpenseInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getExpense } from 'src/store/actions/expense-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        expense: state.expenses.current,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getExpense(id)),
    };
}

const ExpenseInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ExpenseInfo);

export default ExpenseInfoScreen;
